export function getListCountriesAgreements(state) {
  return state.countriesAgreements;
}

export function getListCountriesGroupAgreements(state) {
  return state.countriesGroupAgreements;
}
